import { format } from 'date-fns';

export const monthPlusDayOfMonthFormat = 'MMM do';

export const formatDate = (date: string): string =>
  date &&
  `${format(new Date(date), 'E')}, ${format(new Date(date), 'MMM d')}, ${format(
    new Date(date),
    'yyyy'
  )}`;

export const formatDateWithoutYear = (date: string): string =>
  date &&
  `${format(new Date(date), 'EEEE')}, ${format(new Date(date), 'MMMM d')}`;

export const formatTime = (startTime: string, endTime: string) =>
  startTime &&
  endTime &&
  `${startTime.toLowerCase()}-${endTime.toLowerCase()}`
    .replace(/(:00)?\s*am/g, 'am')
    .replace(/(:00)?\s*pm/g, 'pm');

export const convertTime24to12 = (time24h = ''): string => {
  const timeParts = time24h.split(':');
  const [hours, minutes] = timeParts;

  const hoursInt = parseInt(hours, 10) % 12 || 12;
  const amOrPm = parseInt(hours, 10) >= 12 ? 'PM' : 'AM';

  return `${hoursInt}:${minutes} ${amOrPm}`;
};
